import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import { FightDeathMoments } from "./FightDeathMoments";
import { fightMomentText } from "./fightMomentText";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";

const TITLE = msg({
  id: "finding.died_outnumbered",
  message: "{deaths, plural, one {# death} other {# deaths}} in a fight while outnumbered",
});

const DETAILS = msg({
  id: "finding.died_outnumbered.details",
  message:
    "That is {deaths} of your {totalDeaths, plural, one {# death} other {# deaths}}. The enemies had at least two more heroes nearby for several seconds — there was time to back off.",
});

// Игрок оставался в драке, где врагов рядом хотя бы на двоих больше, и погиб. Иконка — убийца в первой такой смерти.
export const DiedOutnumbered = ({ finding, variant }: FindingProps<"died_outnumbered">) => {
  const { i18n } = useLingui();
  const { deaths, total_deaths: totalDeaths, moments } = finding.params;
  const killer = useAssetLookup("heroes")(moments[0]?.killer_hero_id ?? 0);
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<AssetIcon asset={killer} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { deaths } })}
      details={i18n._({ ...DETAILS, values: { deaths, totalDeaths } })}
      summary={moments.map((moment) => fightMomentText(moment, i18n)).join(" · ")}
    >
      <FightDeathMoments moments={moments} />
    </FindingCard>
  );
};
